import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
// import type { Projects } from '@trinity/chat/api/interfaces/projects';
import type { Projects } from '@trinity/chat/api/interfaces';
import { WorkspacesNavMenu } from '@/components/Workspace/WorkspaceNav';
import { useGroupFeatures } from '@trinity/chat-components/containers/Chat/hooks.js';
import { ProjectStatus } from '@/enums';
import ActiveProjectsPanel from '@/screens/GroupMain/ActiveProjectsPanel';
import { ActiveBrandsPanel } from './ActiveBrandsPanel';
import { useBrandsQuery, useRegisterGlobalChatContext } from './hooks';
import { ScreenLayout } from './Layout';
import { RecentFiles } from './RecentFiles';
import styles from './style/Main.module.css';

const AnalystMain = () => {
  const features = useGroupFeatures();
  const workspacesEnabled = features.workspaces;

  useRegisterGlobalChatContext();

  const projectStatuses = useMemo(() => {
    const statuses = [ProjectStatus.Active];
    return statuses;
  }, []);

  const apiClient = useChatApiClient();

  const query = useQuery({
    queryKey: [
      `get:projects`, {
        index: 0,
        size: 6,
        status: projectStatuses,
      },
    ],
    queryFn: () => {
      return apiClient.projects.fetchProjects({
        index: 0,
        size: 6,
        status: projectStatuses,
      });
    },
    refetchOnWindowFocus: false,
  });

  const brandsQuery = useBrandsQuery();

  const loading = query.isLoading && !query.data;

  const data = loading
    ? getLazyTableData(4)
    : query.data?.items ?? [];

  const empty = query.isFetchedAfterMount && !loading && !data.length;

  return (
    <ScreenLayout>
      <Helmet title="Home" />

      <div className={styles.col}>
        {workspacesEnabled && <WorkspacesNavMenu className={styles.workspaces} />}

        <ActiveBrandsPanel
          query={brandsQuery} />

        <ActiveProjectsPanel
          data={data}
          loading={loading}
          empty={empty} />

        {workspacesEnabled && <RecentFiles />}
      </div>

    </ScreenLayout>
  );
};

export { AnalystMain };
export default AnalystMain;

const getLazyTableData = <T extends Projects.ProjectItem>(pageSize = 25) => {
  return Array.from({ length: pageSize }, _ => ({} as T));
};